import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const postUserGroup = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.GROUP_MANAGEMENT.POST_USER_GROUP,
    data
  );
};

export default postUserGroup;
